export default __webpack_public_path__ + "static/media/05.c6522d6b.png";